import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer", "backdrop", "form", "cardSetSelect"]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    this.handleBeforeCache = this.handleBeforeCache.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
    document.addEventListener("turbo:before-cache", this.handleBeforeCache)
    this.priceTimers = {}
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
    document.removeEventListener("turbo:before-cache", this.handleBeforeCache)
    Object.values(this.priceTimers).forEach(t => clearTimeout(t))
    this.unlockScroll()
  }

  // Reset drawer before Turbo snapshots the page for back/forward cache
  handleBeforeCache() {
    this.closeDrawer()
  }

  // Mobile drawer
  toggleDrawer() {
    if (this.drawerTarget.classList.contains("-translate-x-full")) {
      this.openDrawer()
    } else {
      this.closeDrawer()
    }
  }

  openDrawer() {
    this.drawerTarget.classList.remove("-translate-x-full")
    this.drawerTarget.classList.add("translate-x-0")
    this.backdropTarget.classList.remove("hidden")
    this.lockScroll()
  }

  closeDrawer() {
    this.drawerTarget.classList.add("-translate-x-full")
    this.drawerTarget.classList.remove("translate-x-0")
    this.backdropTarget.classList.add("hidden")
    this.unlockScroll()
  }

  // Auto-submit on dropdown change
  submitForm(event) {
    // If triggered from an element inside a different form (e.g. mobile sort),
    // submit that form. Otherwise submit the main sidebar form.
    const form = event?.target?.closest("form") || this.formTarget
    this.cleanSubmit(form)
  }

  // When game changes, clear card_set and submit
  gameChanged() {
    if (this.hasCardSetSelectTarget) {
      this.cardSetSelectTarget.value = ""
    }
    this.cleanSubmit(this.formTarget)
  }

  // Price range debounce - submit after 500ms pause
  debounceSubmit(event) {
    const field = event.target.name
    clearTimeout(this.priceTimers[field])
    this.priceTimers[field] = setTimeout(() => {
      this.cleanSubmit(this.formTarget)
    }, 500)
  }

  // Submit price on Enter key
  submitOnEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      Object.values(this.priceTimers).forEach(t => clearTimeout(t))
      this.cleanSubmit(this.formTarget)
    }
  }

  // Strip empty inputs before submitting to keep URLs clean
  cleanSubmit(form) {
    const emptyInputs = Array.from(form.elements).filter(el =>
      el.name && el.value === "" && el.type !== "submit"
    )
    emptyInputs.forEach(el => el.disabled = true)
    form.requestSubmit()
    // Re-enable after Turbo captures form data (synchronous in submit handler)
    requestAnimationFrame(() => emptyInputs.forEach(el => el.disabled = false))
  }

  // Keyboard handling
  handleKeydown(event) {
    if (event.key === "Escape" && !this.drawerTarget.classList.contains("-translate-x-full")) {
      this.closeDrawer()
    }
  }

  // Body scroll lock
  lockScroll() {
    document.body.style.overflow = "hidden"
  }

  unlockScroll() {
    document.body.style.overflow = ""
  }
}
